<template>
    <div>
        <div ref="wrapper">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'outside-click-detector',

    methods: {
        handler({ target }) {
            const isOutsideClick = !$(target).closest(this.$el).length;

            if (isOutsideClick) {
                this.$emit('outside');
            }
        },

        registerHandler() {
            $('body').on('click', this.handler);
        },

        unregisterHandler() {
            $('body').off('click', this.handler);
        },
    },

    mounted() {
        this.registerHandler();
    },

    beforeDestroy() {
        this.unregisterHandler();
    },
};
</script>
